import { Component, Input, OnInit } from '@angular/core';
import { tap } from 'rxjs/operators';
import { AssetClassDetailModel, AssetClassModel } from 'src/app/core/asset_class';
import { ConditionRatingV2Service } from 'src/app/views/pages/target-property/services/condition-rating-v2.service';

@Component({
  selector: 'kt-condition-ratin-module-v2',
  templateUrl: './condition-ratin-module-v2.component.html',
  styleUrls: ['./condition-ratin-module-v2.component.scss', '../info-module.styles.scss']
})
export class ConditionRatinModuleV2Component implements OnInit {
  @Input() targetProperty: AssetClassModel;
  @Input() tpDetails: AssetClassDetailModel;

  hasComponents: boolean = true;

  public components$ = this.crService.components$.pipe(tap(components => this.hasComponents = components.length > 0))
  public conditionRatings$ = this.crService.ratings$
  public schemeId$ = this.crService.schemeId$

  constructor(
    private crService: ConditionRatingV2Service
  ) { }

  ngOnInit(): void {
  }

}
